/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiSanctionHitType {
    ACTIVE = 'ACTIVE',
    FILTERED = 'FILTERED'
}


export function instanceOfApiSanctionHitType(value: any): boolean {
    for (const key in ApiSanctionHitType) {
        if (Object.prototype.hasOwnProperty.call(ApiSanctionHitType, key)) {
            if (ApiSanctionHitType[key as keyof typeof ApiSanctionHitType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiSanctionHitTypeFromJSON(json: any): ApiSanctionHitType {
    return ApiSanctionHitTypeFromJSONTyped(json, false);
}

export function ApiSanctionHitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionHitType {
    return json as ApiSanctionHitType;
}

export function ApiSanctionHitTypeToJSON(value?: ApiSanctionHitType | null): any {
    return value as any;
}

export function ApiSanctionHitTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiSanctionHitType {
    return value as ApiSanctionHitType;
}

